import { makeImmutable } from "../../core/makeImmutable";
import { Availability } from "../Availability";
/**
 * Information that the order should be fulfilled as soon as possible.
 */
export class ASAPFulfillmentTime {
    constructor(label) {
        this.type = "ASAP";
        this._label = label;
        makeImmutable(this);
    }
    static empty() {
        return new ASAPFulfillmentTime(null);
    }
    static fromStorageData(storageData) {
        return new ASAPFulfillmentTime(storageData.label);
    }
    get label() {
        return this._label !== null ? this._label : "";
    }
    get availability() {
        return Availability.available();
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return null;
    }
    get storageData() {
        return {
            type: "ASAP",
            label: this.label,
        };
    }
}
